module.exports = __webpack_public_path__ + "media/mike2.b04b78ed.mp3";